import * as React from 'react';

import { wrapWithTooltip } from '../wrap_with_tooltip';
import { Input } from '@cian/ui-kit';

interface ISpecializationFieldProps {
  className: string;
  isValid: boolean;
  value: string;
  change(value: string): void;
}

const SpecializationField = (props: ISpecializationFieldProps) => {
  const textField = (
    <Input
      maxLength={80}
      placeholder={'Агент по жилой недвижимости'}
      value={props.value}
      invalid={!props.isValid}
      onChange={(e, value) => props.change(value)}
    />
  );

  return (
    <div className={props.className}>
      {props.isValid ? textField : wrapWithTooltip(textField, 'Укажите специализацию')}
    </div>
  );
};

export { SpecializationField };
